import { useState, useContext } from "react";
import envConfig from "../envConfig";
import { AuthContext } from "../App";
import Swal from "sweetalert2";

function ZmbAirtelUpload() {
	const { logout } = useContext(AuthContext);
	const [file, setFile]         = useState(null);
	const [isLoading, setIsLoading] = useState(false);
	const [result, setResult]     = useState(null);

	const getToken = () => localStorage.getItem("profishBlue_authToken");

	const handleUpload = () => {
		if (!file) {
			Swal.fire({ title: 'No file selected', text: 'Please choose a CSV, XLS or XLSX file.', icon: 'warning', confirmButtonText: 'OK' });
			return;
		}
		const formData = new FormData();
		formData.append("file", file);
		setIsLoading(true);
		setResult(null);
		fetch(`${envConfig.API_URL}/zmb_airtel/upload`, {
			method: "POST",
			headers: { Authorization: getToken() },
			body: formData,
		})
			.then(async r => {
				const data = await r.json().catch(() => ({}));
				if (r.status === 401) {
					logout();
					window.location.href = "/login";
					return;
				}
				if (!r.ok || data.success !== 1) {
					throw new Error(data.message || `Upload failed (HTTP ${r.status})`);
				}
				setResult(data);
				setFile(null);
				document.getElementById("airtel-file-input").value = "";
			})
			.catch(err => {
				Swal.fire({ title: 'Upload failed', text: err.message, icon: 'error', confirmButtonText: 'OK' });
			})
			.finally(() => setIsLoading(false));
	};

	return (
		<div style={{ minHeight: '100vh', display: 'flex', alignItems: 'flex-start', justifyContent: 'center', paddingTop: '14vh' }}>
		<div style={{ width: '100%', maxWidth: 520, padding: '0 16px' }}>
			<div className="card">
				<div className="card-body p-4">
					<h5 className="mb-4">Zambia — Airtel SMS Delivery Upload</h5>

					<div className="mb-3">
						<label className="form-label fw-semibold">Select file <span className="text-muted fw-normal">(CSV, XLS, XLSX)</span></label>
						<input
							id="airtel-file-input"
							type="file"
							className="form-control"
							accept=".csv,.xls,.xlsx"
							onChange={e => { setFile(e.target.files[0] || null); setResult(null); }}
						/>
					</div>

					<button
						className="btn btn-primary w-100"
						onClick={handleUpload}
						disabled={isLoading || !file}
					>
						{isLoading ? (
							<><span className="spinner-border spinner-border-sm me-2" role="status" />Uploading…</>
						) : 'Upload'}
					</button>

					{result && (
						<div className="alert alert-success mt-4 mb-0">
							<strong>Upload successful</strong>
							<ul className="mb-0 mt-2">
								<li>Rows inserted: <strong>{result.rows_inserted?.toLocaleString()}</strong></li>
								<li>Sheets processed: <strong>{result.sheets_processed}</strong></li>
							</ul>
						</div>
					)}
				</div>
			</div>
		</div>
		</div>
	);
}

export default ZmbAirtelUpload;
